import { Section } from "@models/ISchema";
import { classifySessionLockState } from "./classifySessionLockState";

export const getPastSessionIds = (
  section: Section,
  thresholdDate: string | null,
  canEditPastSessions: boolean,
): string[] => {
  if (canEditPastSessions || !thresholdDate) return [];

  const sessions = [...(section?.sessions ?? []), ...(section?.unasignedSessions ?? [])];

  return sessions
    .filter(
      session => classifySessionLockState(session, thresholdDate, canEditPastSessions) === "all",
    )
    .map(session => session.id);
};
